import { GasFeeMetrics, GasFeeSimulationResults } from '@src/types/gasFees'

export enum TransactionType {
    WRAP = 'wrap',
    APPROVE = 'approve',
    PLACE_ORDER = 'placeOrder',
    TRANSFER = 'transfer',
    DEPOSIT_FOR_BURN = 'depositForBurn',
}

export type PrecomputeGasResults = Record<
    number,
    { feeMetrics: GasFeeMetrics; results: Record<TransactionType, GasFeeSimulationResults> }
>
